<template>
    <div class="noticeDetail">
        <!-- 非空状态 -->
        <!-- <div class="noticeDetailBox" v-if="notRevoked && id && notcieDetailList.lenght > 0">
            <div class="content">
                <div class="title">
                    <div class="notice">公告</div>
                    <p>放假通知</p>
                </div>
                <div class="detail">
                    <div class="detailTitle">
                        这是一个放假通知
                    </div>
                    <div class="detailContent">
                        放假通知内容
                    </div>
                </div>
            </div>
            <div class="footer">
                通知已有103人接收，已确认通知<p>60</p>人，未读<p>43</p>人
            </div>
        </div> -->

         <!-- 空状态 -->

         <div class="noticeDetailBox">
            <img src="@/assets/img/notice/img_yichehui.png" alt="通知已撤回">
            <div class="boxText">通知已被撤回</div>
            <button @click="$router.push('/notice')">返回通知列表</button>
        </div>

        <!-- <div class="noticeDetailBox">
            <div class="content">
                <div class="title">
                    <div class="notice">公告</div>
                    <p>放假通知</p>
                </div>
                <div class="detail">
                    <div class="detailTitle">
                        这是一个放假通知
                    </div>
                    <div class="detailContent">
                        放假通知内容
                    </div>
                </div>
            </div>
            <div class="footer">
                通知已有103人接收，已确认通知<p>60</p>人，未读<p>43</p>人
            </div>
        </div> -->
       

    </div>
</template>
<script>
export default {
    name: "noticeDetail",
    data() {
        return {
            message: "noticeDetail",
            noticeDetailList: [],
            notRevoked: true, // 判断通知是否未被撤回
        }
    },
    created() {
        this.getNoticeDetailList()
    },
    methods: {
        // 获取通知详情内容
        getNoticeDetailList() {
            this.axios.post('/oa/notice/page', {}).then((res) => {
                if (res.code == 0) {
                    this.noticeDetailList = res.data.list
                    this.notRevoked = !this.noticeDetailList[0].isRevoked;
                } else {
                    this.notRevoked = false;
                }
            }).catch((err) => {
                console.log(err);
                this.notRevoked = false;

            })
        },
    }
}
</script>
<style lang="scss" scoped>
.notcieDetail {
    width: 100%;
    height: 100%;
    box-sizing: border-box;

}

.noticeDetailBox {
    width: 100%;
    // height: 936px;
    min-height: calc(100vh - 126px);
    background-color: #FFFFFF;
    // margin-top: 16px;
    margin-bottom: 32px;
    border-radius: 8px;
    position: relative;

    img {
        width: 320px;
        height: 320px;
        position: absolute;
        top: 35%;
        left: 50%;
        transform: translate(-50%, -50%);

    }

    .boxText {
        font-weight: 400;
        font-size: 14px;
        color: #2F3030;
        position: absolute;
        top: 52%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    button {
        width: 116px;
        height: 32px;
        position: absolute;
        top: 58%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: #00B498;
        border-radius: 4px 4px 4px 4px;
        border: none;
        cursor: pointer;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
    }

}

.content {
    width: 100%;
    height: 800px;
    // margin-top: 16px;
    padding: 0 16px;
    background-color: #FFFFFF;
    box-sizing: border-box;



}

.title {
    display: flex;
    justify-content: left;
    align-items: center;
    padding-top: 32px;
    padding-bottom: 32px;

    .notice {
        font-weight: 400;
        font-size: 14px;
        color: #2F3030;
        line-height: 22px;
        background: #FFFFFF;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #EDF2F2;
        padding: 4px 8px;
        margin-right: 16px;
    }

    p {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #939696;
        line-height: 22px;
    }
}

.detail {

    .detailTitle {
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 26px;
        color: #2F3030;
        line-height: 22px;
        margin-bottom: 32px;
        text-align: center;
    }

    .detailContent {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #2F3030;
        line-height: 22px;
        padding: 0 160px;
    }
}

.footer {
    width: 100%;
    box-sizing: border-box;
    background-color: #FFFFFF;
    padding: 32px 176px;
    display: flex;
    align-items: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #939696;
    line-height: 22px;

    p {
        color: #E23C58;
    }
}
</style>